import { PERMISSION_GROUPS } from './permissionGroups';
import { PERMISSION_NAMES } from './permissionNames';

export const PERMISSION_SCOPES = { ANY: 'any' };
export const PERMISSION_TYPES = { ACCESS: 'access' };

export const PERMISSION_RESOURCES = {
  CAN_SEE_JUVENILE_REPORT: {
    group: PERMISSION_GROUPS.RMS,
    name: PERMISSION_NAMES.CAN_SEE_JUVENILE_REPORT,
    type: PERMISSION_TYPES.ACCESS,
  },
  DNA_SAMPLE: { group: PERMISSION_GROUPS.GLOBALS, name: PERMISSION_NAMES.DNA_SAMPLES },
  EMPLOYEE: { group: PERMISSION_GROUPS.GLOBALS, name: PERMISSION_NAMES.EMPLOYEES },
  MERGE_PEOPLE: { group: PERMISSION_GROUPS.GLOBALS, name: PERMISSION_NAMES.MERGE_PEOPLE },
  ZONE: { group: PERMISSION_GROUPS.GLOBALS, name: PERMISSION_NAMES.ZONES },
  PROPERTY: { group: PERMISSION_GROUPS.RMS, name: PERMISSION_NAMES.PROPERTY },
  ALERT: { group: PERMISSION_GROUPS.CAD, name: PERMISSION_NAMES.ALERTS },
  PERSON: { group: PERMISSION_GROUPS.GLOBALS, name: PERMISSION_NAMES.PEOPLE },
  ADDRESS: { group: PERMISSION_GROUPS.GLOBALS, name: PERMISSION_NAMES.ADDRESSES },
  PLACE: { group: PERMISSION_GROUPS.GLOBALS, name: PERMISSION_NAMES.PLACES },
  VEHICLE: { group: PERMISSION_GROUPS.GLOBALS, name: PERMISSION_NAMES.VEHICLES },
};
